export default __webpack_public_path__ + "static/media/falcon-eb.8430d801.svg";